import { RECEIVE_EXTRACAO, CLEAN_EXTRACAO, RECEIVE_EXTRACAO_DATA } from "./extracoesActions";

const EXTRACAO_INITIAL_STATE = { 
    extracaoJBWeb:undefined
}

export default (state = EXTRACAO_INITIAL_STATE, action) => {
    switch (action.type){
        case CLEAN_EXTRACAO:
            return {
                ...state,
                extracaoJBWeb: undefined
            }
        case RECEIVE_EXTRACAO:
            return {
                ...state,
                extracaoJBWeb: action.payload
            }
            case RECEIVE_EXTRACAO_DATA:
            return {
                ...state,
                extracaoDoDia: action.payload
            }
      default:
          return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/relatorios/extracoesReducer.js